import { AnnouncementTranslation } from "../models";

export const getAnnouncementTranslation = (
    translations: AnnouncementTranslation[],
    locale?: string
): AnnouncementTranslation | undefined =>
    translations.find(
        (translation) =>
            translation.languageCode.toLowerCase() === locale?.toLowerCase()
    ) ?? translations[0];

export const replaceNonBreakingSpaces = (html: string): string =>
    html.replace(/&nbsp;|\u00a0/g, " ");
